export const CARROUSEL_CURRENT_ITEM_KEY = 'carrousel';
